// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module--header--1Uhh5","header__link":"Header-module--header__link--1kQvm","minimal":"Header-module--minimal--IKdz_ Header-module--header--1Uhh5"};